import { FaturamentoStatus, FaturamentoTipo, FaturamentoOrigem, FaturamentoHistoricoAcao, Empresa, } from '../generated/backend-enums.js';
export { FaturamentoStatus, FaturamentoTipo, FaturamentoOrigem, FaturamentoHistoricoAcao, Empresa };
export const FaturamentoStatusMap = {
    [FaturamentoStatus.PENDENTE]: 'Pendente',
    [FaturamentoStatus.FATURANDO]: 'Faturando',
    [FaturamentoStatus.FATURADO]: 'Faturado',
    [FaturamentoStatus.PAGO]: 'Pago',
    [FaturamentoStatus.REPROVADO]: 'Reprovado',
    [FaturamentoStatus.DESFEITO]: 'Desfeito',
    [FaturamentoStatus.CANCELADO]: 'Cancelado',
};
export const FaturamentoTipoMap = {
    [FaturamentoTipo.INTERNO]: 'Interno',
    [FaturamentoTipo.REPASSE]: 'Repasse',
    [FaturamentoTipo.INTEGRAL]: 'Integral',
};
export const FaturamentoOrigemMap = {
    [FaturamentoOrigem.PLANILHA]: 'Planilha',
};
export const FaturamentoHistoricoAcaoMap = {
    [FaturamentoHistoricoAcao.CRIACAO]: 'Criado',
    [FaturamentoHistoricoAcao.FATURADO]: 'Faturado',
    [FaturamentoHistoricoAcao.PAGO]: 'Pago',
    [FaturamentoHistoricoAcao.REPROVADO]: 'Reprovado',
    [FaturamentoHistoricoAcao.CANCELADO]: 'Cancelado',
    [FaturamentoHistoricoAcao.DESFEITO]: 'Desfeito',
};
export const EmpresaMap = {
    [Empresa.HUB_PROMO]: 'Hub Promo',
    [Empresa.HUB_MARKETING]: 'Hub Marketing',
};
